import React, { useEffect, useState } from "react";
import "./style.less";

const timeModifier = (value, unit) => {
    let _value = typeof (value) === 'number' ? value : 0;
    if (unit === "minutes") {
        _value = Math.floor(_value / 60);
    }
    if (unit === "seconds") {
        _value = Math.floor(_value % 60);
    }
    return _value
}

const timeFormatter = (value) => {
    const prefix = +value < 10 ? "0" : "";
    return prefix + String(+value);
}

export default ({ value, onChange, onBlur, disabled }) => {

    const minutes = timeModifier(value, 'minutes');
    const seconds = timeModifier(value, 'seconds');

    const setValue = (newValue, unit) => {
        const _minutes = (unit === "minutes" ? +newValue : +minutes) * 60;
        const _seconds = (unit === "seconds" ? +newValue : +seconds);
        onChange(_minutes + _seconds);
    }

    return <div>
        <div className="input-time-container">
            <div className="input-time-group">
                <input
                    type="number"
                    id="minutes"
                    min="0"
                    value={timeFormatter(minutes)}
                    onChange={(e) => setValue(+e.target.value > 999 ? 999 : +e.target.value, 'minutes')}
                    onBlur={onBlur}
                    disabled={disabled}
                />
                <span>мин.</span>
            </div>
            <span className="time-divider">:</span>
            <div className="input-time-group">
                <input
                    type="number"
                    id="seconds"
                    min="0"
                    value={timeFormatter(seconds)}
                    onChange={(e) => setValue(+e.target.value > 60 ? 60 : +e.target.value, 'seconds')}
                    onBlur={onBlur}
                    disabled={disabled}
                />
                <span>сек.</span>
            </div>
        </div>
    </div>
}